<template>
  <v-bottom-sheet v-model="show" @click:outside="appStore.setCookieConsent(false)">
    <v-col>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title>Aviso de Cookies</v-card-title>
            <v-card-text>
              Nós e os terceiros selecionados usamos cookies ou tecnologias similares para finalidades técnicas e, com
              seu consentimento, para outras finalidades conforme especificado na política de privacidade. Use o botão
              "Aceitar" para consentir. Use o botão "Recusar" ou feche este aviso para continuar sem aceitar.
            </v-card-text>
            <v-card-actions>
              <v-row justify="end">
                <v-col cols="4" class="d-flex justify-end mb-4">
                  <v-btn
                    class="mx-4"
                    variant="flat"
                    color="error"
                    @click="appStore.setCookieConsent(false)"
                  >
                    Recusar
                  </v-btn>
                  <v-btn
                    class="mx-4"
                    variant="flat"
                    color="success"
                    @click="appStore.setCookieConsent(true)"
                  >
                    Aceitar
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-bottom-sheet>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useAppStore } from "@/stores/app";

const appStore = useAppStore();

const show = computed({
  get() {
    return !appStore.cookies.prompted;
  },
  set(value: boolean) {
    return value;
  },
});

defineOptions({
  name: "TheCookieDialog",
});
</script>
